@if (hostComponentIsDevicesAllocatedComponent) {
  <div class="page-sticky-header">
    <app-breadcrumbs
      title=""
      [breadcrumbItems]="breadCrumbItems"
    ></app-breadcrumbs>

    <app-page-comp-header
      [filterDate0]="filterDate"
      [filterDate0Format]="filterDateFormat"
      [filterDate0Show]="titlesEmbedDateDropDown"
      [hierarchyFormatting]="superHierarchyEnabled"
      [includeCeasedCompanies]="showCeasedCompanies && includeCeased"
      [initialCompanyId]="filterCompanyID"
      [showCompanyDropdown]="titlesEmbedCompanyDropDown"
      [showSpinner]="showSpinner"
      [title]="title"
      (companyDropDownChange)="companyDropDownOnChange($event)"
      (companyDropDownChange2)="onCompanyDropDownChange2($event)"
      (filterDate0Change)="dateFilterChanged($event)"
    ></app-page-comp-header>
  </div>

  <div class="row mb-3">
    <div class="col-7">
    </div>
    <div class="col-3">
      @if (!titlesEmbedCompanyDropDown) {
        <app-dropdown-company
          [hierarchyFormatting]="superHierarchyEnabled"
          [includeCeased]="showCeasedCompanies && includeCeased"
          [initialCompanyId]="filterCompanyID"
          (selectOnChangeEvent)="companyDropDownOnChange($event)"
          (selectOnChangeEvent2)="onCompanyDropDownChange2($event)"
        ></app-dropdown-company>
      }
    </div>
    <div class="col-2">
      @if (!titlesEmbedDateDropDown) {
        <app-dropdown-date
          [dateFormat]="filterDateFormat"
          [initialDate]="filterDate"
          [monthSelector]="true"
          title="Month"
          (selectOnChangeEvent)="dateFilterChanged($event)"
        ></app-dropdown-date>
      }
    </div>
  </div>

  @if (showWidgets) {

    <div class="card card-animate mb-2 stats-toggle-card" (click)="toggleStatsVisibility()">
      <div class="card-body p-2">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1 overflow-hidden">
            <p class="stats-toggle-text fw-medium text-muted text-truncate text-center mb-0">
              @if (statsHidden) { Show widgets } @else { Hide widgets }
            </p>
          </div>
        </div>
      </div>
    </div>

    @if (!statsHidden) {

      <div class="row g-3 mb-3">

        <div class="col-xl col-md-6">
          <app-stat-tile
            accentColour="info"
            caption="Provisioned"
            icon="bx bx-calendar-plus"
            [label]="isCurrentMonth ? 'New This Month' : 'New in ' + selectedMonthLabel"
            [selectable]="true"
            [selected]="selectedStat==='newInMonth'"
            [value]="statsNewInMonth"
            (tileClick)="statClick('newInMonth')">
          </app-stat-tile>
        </div>

        <div class="col-xl col-md-6">
          <app-stat-tile
            [accentColour]="statsZeroUsage>0 ? 'warning' : 'success'"
            caption="Live SIMs"
            hint="Current-month counts reflect supplier-reported sessions and may be slightly inflated until usage data catches up."
            icon="bx bx-wifi-off"
            label="Zero Usage"
            [selectable]="true"
            [selected]="selectedStat==='zeroUsage'"
            [value]="statsZeroUsage"
            (tileClick)="statClick('zeroUsage')">
          </app-stat-tile>
        </div>

        <div class="col-xl col-md-6">
          <app-stat-tile
            [accentColour]="statsNearLimit>0 ? 'warning' : 'success'"
            [caption]="effectiveNearLimitThreshold + '%-99% of usage cap'"
            icon="bx bx-bar-chart-alt-2"
            label="Near Limit"
            [selectable]="true"
            [selected]="selectedStat==='nearLimit'"
            [value]="statsNearLimit"
            (tileClick)="statClick('nearLimit')">
          </app-stat-tile>
        </div>

        <div class="col-xl col-md-6">
          <app-stat-tile
            [accentColour]="statsOverLimit>0 ? 'danger' : 'success'"
            caption="At or above 100% of usage cap"
            icon="bx bx-trending-up"
            label="Over Limit"
            [selectable]="true"
            [selected]="selectedStat==='overLimit'"
            [value]="statsOverLimit"
            (tileClick)="statClick('overLimit')">
          </app-stat-tile>
        </div>

      </div>

      @if (isCurrentMonth) {
        <div class="row g-3 mb-3">

          <div class="col-xl col-md-6">
            <app-stat-tile
              accentColour="info"
              caption="Provisioned"
              icon="bx bx-plus-circle"
              label="New Today"
              [selectable]="true"
              [selected]="selectedStat==='newToday'"
              [value]="statsNewToday"
              (tileClick)="statClick('newToday')">
            </app-stat-tile>
          </div>

          <div class="col-xl col-md-6">
            <app-stat-tile
              [accentColour]="statsActive>0 ? 'success' : 'danger'"
              caption="Live SIMs"
              icon="bx bx-check-circle"
              label="Active"
              [selectable]="true"
              [selected]="selectedStat==='active'"
              [value]="statsActive"
              (tileClick)="statClick('active')">
            </app-stat-tile>
          </div>

          <div class="col-xl col-md-6">
            <app-stat-tile
              [accentColour]="statsCeasedThisMonth>0 ? 'danger' : 'success'"
              caption="No longer provisioned"
              icon="bx bx-x-circle"
              label="Ceased This Month"
              [selectable]="true"
              [selected]="selectedStat==='ceasedThisMonth'"
              [value]="statsCeasedThisMonth"
              (tileClick)="statClick('ceasedThisMonth')">
            </app-stat-tile>
          </div>

          <div class="col-xl col-md-6">
            <app-stat-tile
              [accentColour]="statsAlerting>0 ? 'danger' : 'success'"
              caption="Barred, suspended or throttled"
              icon="bx bx-error"
              label="Alerting"
              [selectable]="true"
              [selected]="selectedStat==='alerting'"
              [value]="statsAlerting"
              (tileClick)="statClick('alerting')">
            </app-stat-tile>
          </div>

          <div class="col-xl col-md-6">
            <app-stat-tile
              [accentColour]="statsAwaiting>0 ? 'warning' : 'success'"
              caption="Awaiting, downloaded or sent"
              icon="bx bx-time-five"
              label="Awaiting / In Transit"
              [selectable]="true"
              [selected]="selectedStat==='awaiting'"
              [value]="statsAwaiting"
              (tileClick)="statClick('awaiting')">
            </app-stat-tile>
          </div>

        </div>
      }
    }
  }
}

@if (gotDgProperties) {

  <ng-template #bulkActionsToolbar>
    @if (isReseller) {
      <div class="text-muted d-flex align-items-center me-3">
        <i class="ri-information-line align-bottom me-1"></i>
        Please select a company to use bulk operations.
      </div>
    } @else {
      <div class="me-3" ngbDropdown container="body">
        <button type="button"
                class="btn btn-info add-btn"
                id="bulkActionsDropdown"
                ngbDropdownToggle
                [disabled]="!canBulkAction">
          <i class="ri-list-settings-line align-bottom me-1"></i>
          Bulk Actions
          @if (canBulkAction) { <span class="badge bg-light text-dark ms-1">{{ selectedSims.length }}</span> }
        </button>
        <div ngbDropdownMenu aria-labelledby="bulkActionsDropdown">
          <button type="button" ngbDropdownItem (click)="openBulkAction(BulkSimAction.ChangeProduct)">Change Product</button>
          <button type="button" ngbDropdownItem (click)="openBulkAction(BulkSimAction.Suspend)">Suspend</button>
          <button type="button" ngbDropdownItem (click)="openBulkAction(BulkSimAction.Cease)">Cease</button>
          <button type="button" ngbDropdownItem (click)="openBulkAction(BulkSimAction.Throttle)">Throttle</button>
          <button type="button" ngbDropdownItem (click)="openBulkAction(BulkSimAction.OverrideLimit)">Override Limit</button>
          <button type="button" ngbDropdownItem (click)="openBulkAction(BulkSimAction.ChangeThisMonthLimit)">Change This Month's Limit</button>
        </div>
      </div>
    }
  </ng-template>

  <!-- RBW_20260618 - autoLoad off only when standalone (the company dropdown drives the first load). Embedded
       dashboard/usage hosts company dropdown may have trigged before grid is created, so they must self-load or the grid never hits the API. -->
  <!-- [autoLoad]="hostComponentIsDevicesAllocatedComponent ? false : true" -->
  <app-grid-view #gridView
    [apiPath]="dgApiPath"
    [continuousLoadPanel]="true"
    [dgActionColumn]="dgActionColumn"
    [dgColumns]="dgColumns"
    [dgPopup]="dgPopup"
    [dgProperties]="dgProperties"
    [dgTabs]="hostComponentIsDevicesAllocatedComponent ? dgTabs : undefined"
    [toolbarStartTemplate]="showBulkToolbar ? bulkActionsToolbar : undefined"
    (addButtonClick)="gridAddButtonClick($event)"
    (cellClick)="cellClick($event)"
    (checkbox0Change)="onCheckboxChange($event)"
    (checkbox1Change)="onCheckbox1Change($event)"
    (contentReady)="gridContentReady()"
    (editButtonClick)="gridEditButtonClick($event)"
    (locationButtonClick)="gridLocationButtonClick($event)"
    (messageButtonClick)="gridMessageButtonClick($event)"
    (moreButtonClick)="gridMoreButtonClick($event)"
    (riskButtonClick)="gridRiskButtonClick($event)"
    (selectionChanged)="onGridSelectionChanged($event)"
    (tabChanged)="onTabChange($event)"
  ></app-grid-view>
}

<app-bulk-sim-actions-modal-form #bulkSimActions
  (completed)="onBulkCompleted()"
></app-bulk-sim-actions-modal-form>

<app-communication-compose-modal-form #communicationComposeModalForm
  [useTrmChannelParams]="hostComponentIsTravelRiskManagementComponent"
></app-communication-compose-modal-form>

<app-company-modal-form #companyModalForm
  (companyFormCancelled)="companyFormHasBeenCancelled()"
  (iccidClicked)="iccidClicked($event)"
  (sureSimCompanyDataHasBeenSaved)="companyDataHasBeenSaved($event)"
></app-company-modal-form>

<app-manage-esim-modal-form #manageEsimModalForm
  (orderDataHasBeenSaved)="orderDataHasBeenSaved()"
  (orderStatusHasBeenUpdated)="orderStatusHasBeenUpdated()"
  (eSimManagerFormCancelled)="manageEsimFormHasBeenCancelled()"
  (riskButtonClick)="manageEsimRiskButtonClick($event)"
></app-manage-esim-modal-form>

<app-manage-esim-modal-form-more #manageEsimMore
  (moreFormCancelled)="moreFormHasBeenCancelled($event)"
  (moreFormHasBeenSaved)="moreFormHasBeenSaved()"
></app-manage-esim-modal-form-more>

<app-page-comp-menu-primeng #morePopupMenu
  [menuItems]="moreMenuItems"
></app-page-comp-menu-primeng>

<app-riskline-trip-ready-modal-form #riskTripReadyModalForm
  (formCancelled)="riskTripReadyFormHasBeenCancelled()"
></app-riskline-trip-ready-modal-form>

<app-timeline-esim-modal-form #timelineModalForm
  (riskButtonClick)="manageEsimRiskButtonClick($event)"
></app-timeline-esim-modal-form>

<app-user-modal-form #userModalForm
  (sureSimUserDataHasBeenSaved)="userDataHasBeenSaved($event)"
  (userFormCancelled)="userFormHasBeenCancelled()"
></app-user-modal-form>
